module.exports = __webpack_public_path__ + "img/807.48732a4e.png";